import freightApi from 'core/services/api/freightApi'

const path = '/v1/local-deliveries'

export const browse = (paginate = { page: 1, per_page: 10 }, active = true) => {
  const { page, per_page } = paginate

  return freightApi.request({
    url: path,
    params: { page, per_page, active },
  })
}
